import {
  Box,
  Center,
  GridItem,
  SimpleGrid,
  Square,
  Text,
} from "@chakra-ui/react";
import React from "react";

import CoverImageBlob from "adminComponents/molecules/CoverImageBlob";
import { pxToRem } from "adminComponents/utils/pxToRem";
import {
  CoverImageBGColorSchemeType,
  CoverImageBGPatternType,
  CoverImageIconType,
} from "links/lib/types";
import { Card } from "sessionComponents/atoms/Card";
import { useBreakpoints } from "sessionComponents/contexts/breakpoints";

export interface IPracticeSetCardProps {
  coverImageBGColorScheme: CoverImageBGColorSchemeType;
  coverImageIcon: CoverImageIconType;
  coverImageBGPattern: CoverImageBGPatternType;
  practiceSetName: string;
  teacherTitle: string;
  className: string;
}

export const PracticeSetCard: React.FC<IPracticeSetCardProps> = ({
  coverImageBGColorScheme,
  coverImageBGPattern,
  coverImageIcon,
  practiceSetName,
  teacherTitle,
  className,
}) => {
  const { match: currentBreakpoints } = useBreakpoints();
  const coverImageSize = currentBreakpoints.buttonHeight * 2;
  return (
    <Box h="100%" padding={pxToRem(currentBreakpoints.margin)}>
      <Card h="100%" useThickBorder>
        <Square size="100%">
          <SimpleGrid columns={1}>
            <GridItem>
              <Center>
                <Box>
                  <CoverImageBlob
                    icon={coverImageIcon}
                    backgroundColorScheme={coverImageBGColorScheme}
                    backgroundPattern={coverImageBGPattern}
                    boxSize={coverImageSize}
                  />
                </Box>
              </Center>
            </GridItem>
            <GridItem m={pxToRem(currentBreakpoints.margin)}>
              <Center>
                <Box
                  display="-webkit-box"
                  sx={{
                    WebkitLineClamp: "4",
                    WebkitBoxOrient: "vertical",
                  }}
                  overflow="hidden"
                >
                  <Text
                    textAlign="center"
                    fontSize={pxToRem(currentBreakpoints.fontSize * 1.5)}
                    textStyle="gameDisplay"
                  >
                    {practiceSetName}
                  </Text>
                </Box>
              </Center>
            </GridItem>
            <GridItem>
              <Center>
                <Box
                  display="-webkit-box"
                  sx={{
                    WebkitLineClamp: "4",
                    WebkitBoxOrient: "vertical",
                  }}
                  overflow="hidden"
                >
                  <Text
                    fontSize={pxToRem(currentBreakpoints.fontSize)}
                    textStyle="gameText"
                    textAlign="center"
                  >
                    {teacherTitle} - {className}
                  </Text>
                </Box>
              </Center>
            </GridItem>
          </SimpleGrid>
        </Square>
      </Card>
    </Box>
  );
};
